import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UsageData } from '@paragon/contract-library';

type UsageDataState = UsageData | null;

const usageDataSlice = createSlice({
  name: 'usageData',
  initialState: null as UsageDataState,
  reducers: {
    usageDataLoaded: (_, action: PayloadAction<UsageData>) => action.payload,
  },
});

export const { usageDataLoaded } = usageDataSlice.actions;
export const usageData = usageDataSlice.reducer;
